'use strict';
const Router = require('autor');
const pdf    = require('./pdf.js');
const screen = require('./screen.js');
import {randInt} from './helpers.js';

class Route extends Router.Route {
  load(resolve) {
    Router.post(document.location.origin + Router.location.pathname + '?partial', {}, (err, req) => {
      document.body.setAttribute('data-path', Router.location.pathname);
      document.querySelector('main').innerHTML = req.responseText;
      window.scrollTo( 0, 0 );
      resolve();
    });
  }

  bootstrap(route) {
    if (typeof route.title !== 'undefined') document.getElementById('overlay-title').innerHTML = route.title;
    else document.getElementById('overlay-title').innerHTML = '';
    // staticDot.placeRandomDot();
    if (typeof route.title !== 'undefined') document.title = 'All Conference — ' + route.title;
    else document.title = 'All Conference';
    showRandomImage();
  }
}

let lastImage = null;

function getRandomImageExceptLast() {
  let images = document.getElementsByClassName('rotating-images__image');
  let randomImage = images[randInt(0, images.length - 1)];
  if (randomImage !== lastImage) {
    lastImage = randomImage;
    return randomImage;
  } else {
    return getRandomImageExceptLast();
  }
}

function showRandomImage() {
  if (Router.route.path !== '/contact') return;
  if (document.querySelector('.rotating-images__image') == null) return;

  if (window.innerWidth > 700) {
    let prevImage = lastImage;
    let image = getRandomImageExceptLast();
    image.style.left = randInt(30, 50) + '%';
    image.style.top = randInt(10, 65) + '%';
    image.style.display = 'block';
    if (prevImage != null) prevImage.style.display = 'none';
  }
  setTimeout(showRandomImage, 10000);
}

module.exports = Route;



// WEBPACK FOOTER //
// ./src/js/contact.service.js